import { Link } from "react-router-dom";
import { useState } from "react";
import BrandLogo from "@/components/BrandLogo";
import { Menu, X, ArrowRight } from "lucide-react";

const NAV = [
  { label: "Corporate", to: "/corporate" },
  { label: "Malls", to: "/malls" },
  { label: "Colleges & Universities", to: "/education" },
  { label: "K-12 Schools", to: "/schools" },
  { label: "Expressways", to: "/expressways" },
];

/** Shared top nav for marketing pages — landing + 5 vertical pages. */
export default function MarketingNav({ onCta }) {
  const [mobile, setMobile] = useState(false);

  return (
    <header className="sticky top-0 z-30 bg-cream-50/85 backdrop-blur-md border-b border-cream-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="mkt-home">
          <BrandLogo size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map(n => (
            <Link key={n.to} to={n.to} data-testid={`mkt-nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')}`}
              className="px-3 py-2 text-sm font-semibold text-ink-700 hover:text-brand hover:bg-cream-100 rounded-full transition-colors">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button onClick={onCta} data-testid="mkt-cta-top"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-ink text-white text-sm font-semibold hover:bg-ink-700">
            Get a demo <ArrowRight size={14}/>
          </button>
          <button onClick={() => setMobile(o => !o)}
            className="md:hidden p-2 rounded-full hover:bg-cream-200" data-testid="mkt-mobile-menu">
            {mobile ? <X size={18}/> : <Menu size={18}/>}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t border-cream-200/60 bg-cream-50">
          <div className="px-4 py-2 space-y-1">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} onClick={() => setMobile(false)}
                className="block px-3 py-2 text-sm font-semibold text-ink-700 hover:bg-cream-100 rounded-lg">
                {n.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
